const addOnsTypes = {
    BOOKING_ONLY: 1,
    CONFIRMATION_PAGE_ONLY: 2,
    BOOKING_AND_CONFIRMATION_PAGE: 3
};

const addOnsCrossSellConfigItems = [
    {
        code: 'showAddOnCrossSellInProductDetails',
        title: 'Product Details (applies when retailing is enabled)'
    },
    {
        code: 'showAddOnCrossSellInAddedToCartOverlay',
        title: 'Added to Cart overlay'
    },
    {
        code: 'showAddOnCrossSellOnCartPage',
        title: 'Shopping Cart page'
    },
    {
        code: 'showAddOnCrossSellOnConfirmationPage',
        title: 'Confirmation page'
    }
];

const travelAgencyDisplayNameOptions = [
    { key: 'displayTravelAgencyCompanyName', label: 'Display Travel Agency Company Name' },
    { key: 'displayTravelAgencyBusinessName', label: 'Display Travel Agency Business Name (DBA)' }
];

const thirdPartyOffersConfigItems = [
    {
        code: 'enableTripteasePriceCheckLite',
        title: 'Triptease Offers',
        provider: 'Triptease',
        description: 'Add an OTA price comparison component to your Room List page.',
        configuredText: 'Currently configured: Price Check Lite',
        infoTooltip: {
            title: 'Price Check Lite',
            paragraphs: [
                'Triptease Price Check Lite is a website component designed for hotels that displays real-time price comparisons between the booking engine and OTAs, but it does not match pricing.'
            ]
        },
        sectionRefOffset: 0
    },
    {
        code: 'enableCancelForAnyReasonByHTS',
        title: 'Cancel for Any Reason',
        provider: 'HTS',
        description: 'Add a paid cancellation offer to your Add-ons page.',
        detailsText: 'Credit card payment is required for a Cancel for Any Reason purchase.',
        infoTooltip: {
            title: 'Cancel for Any Reason',
            paragraphs: [
                'HTS (Hopper Technology Solutions) Cancel for Any Reason (CFAR) allows travelers to add a fee-based add-on to their room that enables them to cancel for any reason without documentation.',
                'Cancel for Any Reason (offered on the Add-ons page) and Protect Your Booking (offered on the Checkout page) are similar products and may be redundant for guests.'
            ]
        },
        sectionRefOffset: 1
    },
    {
        code: 'enableProtectGroupBookingProtection',
        title: 'Protect Your Booking',
        provider: 'Protect Group',
        description: 'Add a booking protection offer to your Checkout page.',
        infoTooltip: {
            title: 'Protect Your Booking',
            paragraphs: [
                'Protect Group booking protection allows guests to add a refundable option to typically non-refundable bookings for an extra fee.',
                'If a guest cannot attend due to unforeseen circumstances (illness, injury, transport disruption), Protect Group handles the refund process.',
                'Protect Your Booking, offered on the Checkout page, and Cancel for Any Reason, offered on the Add-ons page, are similar products and may be redundant for guests.',
                'Protect Your Booking and Sensible Weather Guarantee offers both appear on the Checkout page, competing for guests attention and limited real estate.'
            ]
        },
        sectionRefOffset: 2
    },
    {
        code: 'enableWeatherGuaranteeBySensibleWeather',
        title: 'Weather Guarantee',
        provider: 'Sensible Weather',
        description: 'Add a weather guarantee offer to your Checkout page.',
        detailsText:'Email address, country, and ZIP/postal code fields, and a credit card must be required at Checkout.',
        infoTooltip: {
            title: 'Weather Guarantee',
            paragraphs: [
                'Sensible Weather guarantees provide automatic reimbursement for bookings when rain or high temperatures exceed defined thresholds during the guest stay.',
                'Guests purchase it during booking, Sensible monitors the weather, and if it triggers, they automatically send the guest money—no claims filing required.',
                'Sensible Weather Guarantee and Protect Your Booking offers both appear on the Checkout page, competing for guest attention and limited real estate.'
            ]
        },
        sectionRefOffset: 3
    }
];

export { addOnsTypes, addOnsCrossSellConfigItems, thirdPartyOffersConfigItems, travelAgencyDisplayNameOptions };



// WEBPACK FOOTER //
// ./src/constants/GeneralConfiguration.js